import React from 'react';

import { CameraOffIcon, ArrowInCircleRightIcon } from '@vlabs/icons';
import { EmptyCard } from '@vlabs/shared/components/empty-card';
import { ButtonScrimGroup, Control } from '@vlabs/uikit';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import st from './EmptyImage.module.sass';

export const EmptyImage = ({
  className = undefined,
  messageText = undefined,
  dataTip = undefined,
  onImageClick = undefined,
  icon = undefined,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(st.Root, className)}
      {...props}
    >
      <EmptyCard
        dataTip={dataTip}
        icon={icon || <CameraOffIcon className={st.CameraOffIcon} />}
        text={messageText || t('no_image')}
      />

      {onImageClick && (
        <ButtonScrimGroup
          className={st.GoTo}
          data-testid="emptyImage.goToButton"
        >
          <Control.IconButton
            icon={<ArrowInCircleRightIcon />}
            onClick={onImageClick}
          />
        </ButtonScrimGroup>
      )}

    </div>
  );
};

EmptyImage.propTypes = {
  className: PropTypes.string,
  messageText: PropTypes.string,
  dataTip: PropTypes.string,
  onImageClick: PropTypes.func,
  icon: PropTypes.element,
};
